module.exports = "https://static.wmbcdn.com/uniweb/images/b47c424528405f93bbbdad770eb1abb3.svg";